var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMusicSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 15.54c0-1.28 1.04-2.32 2.32-2.32 1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32-1.28 0-2.32-1.04-2.32-2.32zm1.5 0c0 .45.37.82.82.82.45 0 .82-.37.82-.82 0-.45-.37-.82-.82-.82-.45 0-.82.37-.82.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24 15.54V9.21c0-.96.6-1.74 1.52-1.99l3.14-.86c.95-.26 1.55-.01 1.88.24.48.37.72.95.72 1.74v6.14c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8.34c0-.33-.07-.51-.13-.55-.05-.04-.23-.08-.58.01l-3.14.86c-.28.08-.41.25-.41.54v6.33c0 .42-.34.76-.75.76s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 14.49c0-1.28 1.04-2.32 2.32-2.32 1.28 0 2.32 1.04 2.32 2.32 0 1.28-1.04 2.32-2.32 2.32-1.28 0-2.32-1.04-2.32-2.32zm1.5 0c0 .45.37.82.82.82.45 0 .82-.37.82-.82 0-.45-.37-.82-.82-.82-.45 0-.82.37-.82.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.269 11.24a.75.75 0 0 1 .53-.92l5.76-1.57a.75.75 0 1 1 .39 1.45l-5.76 1.57c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-square.9f7f65c6c3b98cc9452ea79754ff24e3.svg";
export { ForwardRef as ReactComponent };